import { Backdrop, CircularProgress} from "@mui/material";
import CChooseFile from "../../../basecomp/components/CChooseFile";
import { useTranslation } from "react-i18next";
import CText from "../../../basecomp/components/CText";
import { Box } from "@mui/system";
import CButton from "../../../basecomp/components/CButton";
import { useState } from "react";
// import axios from "axios";
import AxiosWrapper, { axiosGetCallHeaderWithToken } from "../../../basecomp/base/AxiosWrapper";
import { Download} from "@mui/icons-material";
import { useToast } from "../../../basecomp/components/provider/ToastProvider";

const Base_URL = process.env.REACT_APP_BE_URL;

function DataUpload() {
    const { t } = useTranslation()
    const { handleToastOpen } = useToast();
    const [isLoading,setIsLoading]=useState(false)

    const [uploadedFiles, setUploadedFiles] = useState({})
    const handleFileChoose = (type, files) => {
        console.log("type", type);
        console.log("files", files);
        setUploadedFiles({
            ...uploadedFiles,
            [type]: files[0],
        })
    };
    const handelSubmitButtonClick = async () => {
        setIsLoading(true)
        // if(!uploadedFiles.sbinlocation){

        //     if (!uploadedFiles.sq01 || !uploadedFiles.mb51 ) {
        //         handleToastOpen("error", "Kindly upload both sq01 and mb51 files");
        //         setIsLoading(false);
        //         return
        //     }
        // }
        // if(uploadedFiles.sbinlocation){
        //     console.log("file hai");
        // }
        // else{
        //     console.log("file nhi h");
        // }
        if (
    !uploadedFiles.sq01 &&
    !uploadedFiles.mb51 &&
    !uploadedFiles.sbinlocation &&
    !uploadedFiles.temp_location
) {
    handleToastOpen(
        "error",
        "Kindly upload at least one file (SQ01, MB51 or SBIN)"
    );
    setIsLoading(false);
    return;
}
        let formData = new FormData()

        formData.append("sq01", uploadedFiles.sq01)
        formData.append("mb51", uploadedFiles.mb51)
        // formData.append("globalterminal", uploadedFiles.globalterminal)
        if(uploadedFiles.sbinlocation){
            formData.append("sbinlocation", uploadedFiles.sbinlocation)
        }
        if(uploadedFiles.temp_location){
            formData.append("temp_location", uploadedFiles.temp_location)
        }
        try {
            let response = await AxiosWrapper.axiosPostCallWithToken(`${Base_URL}/label_print/dataUpload`, formData)
            console.log(response);
            setIsLoading(false)
            if (response.data.status) {
                // handleToastOpen("success","Files Uploaded")
                alert("Files Uploaded")
                window.location.reload();
                // setUploadedFiles({})

            }

        }
        catch (error) {
            handleToastOpen("error", error.response.data.message)
            console.log(error.response);
            setIsLoading(false)
        }
    }
    const handleSampleFileDownload = async (type) => {
        let response = await axiosGetCallHeaderWithToken(
            `${Base_URL}/label_print/getSampleCsv?type=${type}`,
            { responseType: "blob" }
        );
        const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${type}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
    return (
        <>

            <Box sx={{ p: 10 }}>
                <Box sx={{ display: "flex", justifyContent: "space-evenly" }}>
                    <Box>
                        {/* <CText cText={"sq01 data"}></CText> */}
                        <div>Sq01 data <sup style={{color:"red"}}>*</sup></div>
                        <Box sx={{ display: "flex", gap: 3 ,marginTop:2}}>
                            <CChooseFile
                                cFileType="XCL"
                                cTooltipText={t("Download sq01 sample file")}
                                cHelperText={t("file_type")}
                                cHandleFileChange={(files) => handleFileChoose("sq01", files)}
                                // cFullWidth={true}
                                cIsRequired={true}
                            />
                            <CButton
                                cSrc={<Download />}
                                cIsMain={true}
                                cTooltipText={t("Download sq01 sample file")}
                                cOnClick={() => handleSampleFileDownload("sq01")}
                            />
                        </Box>
                    </Box>
                    <Box>
                        {/* <CText cText={"Mb51 data"}></CText> */}
                        <div>Mb51 data <sup style={{color:"red"}}>*</sup></div>

                        <Box sx={{ display: "flex", gap: 3,marginTop:2 }}>
                            <CChooseFile
                                cFileType="XCL"
                                cTooltipText={t("Download sample mb51 file")}
                                cHelperText={t("file_type")}
                                cHandleFileChange={(files) => handleFileChoose("mb51", files)}
                                cFullWidth={true}
                                cIsRequired={true}
                            />
                            <CButton
                                cSrc={<Download />}
                                cIsMain={true}
                                cTooltipText={t("Download sample mb51 file")}
                                cOnClick={() => handleSampleFileDownload("mb51")}
                            />
                        </Box>
                    </Box>
                    <Box>
                        {/* <CText cText={"Mb51 data"}></CText> */}
                        <div>S_bin_location data <sup style={{color:"red"}}>*</sup></div>

                        <Box sx={{ display: "flex", gap: 3,marginTop:2 }}>
                            <CChooseFile
                                cFileType="XCL"
                                cTooltipText={t("Download sample sBinLocation file")}
                                cHelperText={t("file_type")}
                                cHandleFileChange={(files) => handleFileChoose("sbinlocation", files)}
                                cFullWidth={true}
                                cIsRequired={true}
                            />
                            <CButton
                                cSrc={<Download />}
                                cIsMain={true}
                                cTooltipText={t("Download sample sBinLocation file")}
                                cOnClick={() => handleSampleFileDownload("sbinlocation")}
                            />
                        </Box>
                    </Box>
                    <Box>
                        {/* <CText cText={"Mb51 data"}></CText> */}
                        <div>temp location data<sup style={{color:"red"}}>*</sup></div>

                        <Box sx={{ display: "flex", gap: 3,marginTop:2 }}>
                            <CChooseFile
                                cFileType="XCL"
                                cTooltipText={t("Download sample temp location file")}
                                cHelperText={t("file_type")}
                                cHandleFileChange={(files) => handleFileChoose("temp_location", files)}
                                cFullWidth={true}
                                cIsRequired={true}
                            />
                            <CButton
                                cSrc={<Download />}
                                cIsMain={true}
                                cTooltipText={t("Download sample temp_location file")}
                                cOnClick={() => handleSampleFileDownload("temp_location")}
                            />
                        </Box>
                    </Box>
                   
                </Box>
                <Box sx={{ display: "flex", width: "100%", justifyContent: "center", marginTop: 5 }}>
                    <CButton cText={"          upload         "} cOnClick={handelSubmitButtonClick}></CButton>
                </Box>

                <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={isLoading}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </Box>
        </>
    )
}

export default DataUpload